/* eslint-disable */
import React from "react";
import RenderITOfficerPage from "../RenderITOfficerPage";
import FundContributionAnalysisPanel from "../../Components/FundContributionAnalysisPanel";

function FundContributionAnalysis() {
  return (
    <RenderITOfficerPage title="Fund Contribution Analysis">
      <FundContributionAnalysisPanel accent="cyan" />
    </RenderITOfficerPage>
  );
}

export default FundContributionAnalysis;
